import { getUnreadMessageStatus } from '@/apis/letter'
import useSWR from 'swr'
import { useRecoilValue } from 'recoil'
import { userState } from 'Store/user'

export function useLetterReadStatus() {
  const user = useRecoilValue(userState)
  const { data, mutate } = useSWR(
    user && {
      endpoint: '/system_message_notification/read_status',
      user_id: user?.user_id,
    },
    () => getUnreadMessageStatus()
  )

  return { data, mutate }
}
